import checks from "./checks/index.js";
import deleteMultipleBricks from "./delete-multiple-bricks.js";
import getMultiple from "./get-multiple.js";
import createMultiple from "./create-multiple.js";
import createMultipleFields from "./create-multiple-fields.js";
import createMultipleGroups from "./create-multiple-groups.js";

export default {
	checks,
	deleteMultipleBricks,
	getMultiple,
	createMultiple,
	createMultipleFields,
	createMultipleGroups,
};
